export default {
  pages: {
    bmlSearchClients: {
      title: 'Mijozni qidirish',
      dateOfBirth: "Tug'ilgan sanasi",
      findClient: 'Mijozni qidirish',
    },
  },
};
